// icon:window-maximize | Tabler Icons https://tablericons.com/ | Csaba Kissi
import * as React from "react";

function IconWindowMaximize2(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M4 16 H7 A1 1 0 0 1 8 17 V20 A1 1 0 0 1 7 21 H4 A1 1 0 0 1 3 20 V17 A1 1 0 0 1 4 16 z" />
      <path d="M4 12V6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2h-6" />
      <path d="M12 8h4v4M16 8l-5 5" />
    </svg>
  );
}

export default IconWindowMaximize2;
